import './TicketInfo.css';

const TicketInfo = ({ ticket }) => {
  return (
    <div className="ticket-info">
      <div className="ticket-info__header">
        <div className="ticket-info__icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        </div>
        <span className="ticket-info__title">Заявка создана</span>
      </div>
      
      <div className="ticket-info__details">
        <div className="ticket-info__row">
          <span className="ticket-info__label">Тема:</span>
          <span className="ticket-info__value">{ticket.topic}</span>
        </div>
        
        <div className="ticket-info__row">
          <span className="ticket-info__label">Отдел:</span>
          <span className="ticket-info__value">{ticket.department}</span>
        </div>
        
        <div className="ticket-info__row">
          <span className="ticket-info__label">Дата создания:</span>
          <span className="ticket-info__value">
            {new Date(ticket.createdAt).toLocaleString('ru-RU', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TicketInfo; 